import React, { Component, Fragment } from 'react'
import { Router, Route, Switch } from "react-router";
import HomePage from "../pages/HomePage";
import { Routes } from "react-router-dom";
import AppURL from '../api/AppURL';
import AboutPage from '../pages/AboutPage';
import CartPage from '../pages/CartPage';
import ContactPage from '../pages/ContactPage';
import FavouritePage from '../pages/FavouritePage';
import ForgetPasswordPage from '../pages/ForgetPasswordPage';
// import HomePage from '../pages/HomePage';
import NotificationPage from '../pages/NotificationPage';
import PrivacyPage from '../pages/PrivacyPage';
import ProductCategoryPage from '../pages/ProductCategoryPage';
import ProductDetailsPage from '../pages/ProductDetailsPage';
import ProductSubCategoryPage from '../pages/ProductSubCategoryPage';
import ProfilePage from '../pages/ProfilePage';
import PurchasePage from '../pages/PurchasePage';
import RefundPage from '../pages/RefundPage';
import RegisterPage from '../pages/RegisterPage';
import ResetPasswordPage from '../pages/ResetPasswordPage';
import SearchPage from '../pages/SearchPage';
import UserLoginPage from '../pages/UserLoginPage';
import axios from 'axios'
import NavMenuDesktop from '../components/common/NavMenuDesktop';
import OrderListPage from '../pages/OrderListPage';


class AppRoute extends Component {



     // এখানে user হলো state স্টেটের একটি প্রপার্টি বা অবজেক্ট 
     // this.state হলো পুরো স্টেট অবজেক্ট।
     //প্রথমে user ইউজারকে ফাকা বা empty রাখা হয়েছে
     constructor() {
          super();
          this.state = {
               user: {}
          }
     }

     componentDidMount() {
          axios.get(AppURL.UserData).then((response) => {
               this.setUser(response.data)
          }).catch(error => {

          });
     }


     //setUser একটি  ফাংশন
     //এখানে user হলো setUser ফাংশনের একটি প্যারামিটার
     setUser = (user) => {
          this.setState({ user: user })
     }

     render() {
          return (
               // <Fragment>

               //      <NavMenuDesktop user={this.state.user} setUser={this.setUser} />

               //      <Switch>


               //           <Route exact path="/" render={(props) => <HomePage {...props} key={Date.now()} />} />

               //           <Route exact path="/login" render={(props) => <UserLoginPage user={this.state.user} setUser={this.setUser}  {...props} key={Date.now()} />} />

               //           <Route exact path="/register" render={(props) => <RegisterPage user={this.state.user} setUser={this.setUser} {...props} key={Date.now()} />} />

               //           <Route exact path="/forget" render={(props) => <ForgetPasswordPage {...props} key={Date.now()} />} />

               //           <Route exact path="/reset/:id" render={(props) => <ResetPasswordPage {...props} key={Date.now()} />} />

               //           <Route exact path="/profile" render={(props) => <ProfilePage user={this.state.user} setUser={this.setUser}  {...props} key={Date.now()} />} />




               //           <Route exact path="/contact" render={(props) => <ContactPage {...props} key={Date.now()} />} />

               //           <Route exact path="/purchase" render={(props) => <PurchasePage {...props} key={Date.now()} />} />

               //           <Route exact path="/privacy" render={(props) => <PrivacyPage {...props} key={Date.now()} />} />

               //           <Route exact path="/refund" render={(props) => <RefundPage {...props} key={Date.now()} />} />

               //           <Route exact path="/about" render={(props) => <AboutPage {...props} key={Date.now()} />} />

               //           <Route exact path="/productdetails/:code" render={(props) => <ProductDetailsPage user={this.state.user}  {...props} key={Date.now()} />} />

               //           <Route exact path="/notification" render={(props) => <NotificationPage {...props} key={Date.now()} />} />

               //           <Route exact path="/favourite" render={(props) => <FavouritePage user={this.state.user} {...props} key={Date.now()} />} />

               //           <Route exact path="/cart" render={(props) => <CartPage user={this.state.user} {...props} key={Date.now()} />} />

               //           <Route exact path="/productcategory/:category" render={(props) => <ProductCategoryPage {...props} key={Date.now()} />} />

               //           <Route exact path="/productsubcategory/:category/:subcategory" render={(props) => <ProductSubCategoryPage {...props} key={Date.now()} />} />

               //           <Route exact path="/productbysearch/:searchkey" render={(props) => <SearchPage {...props} key={Date.now()} />} />

               //           <Route exact path="/orderlist" render={(props) => <OrderListPage user={this.state.user} {...props} key={Date.now()} />} />


               //      </Switch>

               // </Fragment>

               <Fragment>

                    <NavMenuDesktop user={this.state.user} setUser={this.setUser} />

                    <Routes>

                         {/* 
                         
                         package.json-এ "react-router-dom": "^6.27.0" উল্লেখ থাকলে, React Router এর ভার্সন 6 ব্যবহার হচ্ছে, যেখানে Route কম্পোনেন্টে element প্রপার্টি ব্যবহার করা হয়। 
                         তাই  নিচের প্রথমটি (React Router v6 অনুযায়ী সঠিক) ব্যবহার করবে:
                         <Route exact path="/" element={<HomePage />} />, element প্রপার্টি সাধারণত React Router v6 বা এর পরবর্তী ভার্সনে ব্যবহৃত হয়।
                         <Route exact path="/" render={(props) => <HomePage {...props} key={Date.now()} />} /> এটি React Router এর render প্রপার্টি ব্যবহার করে কম্পোনেন্ট রেন্ডার করছে, যা React Router v5 এর জন্য সাধারণত ব্যবহৃত হয়। 
                         এখানে একটি ফাংশন পাস করা হয়েছে যা প্রতিবার Date.now() দ্বারা একটি নতুন key প্রদান করছে। এর ফলে প্রতিবার যখন রুটটি অ্যাক্সেস করা হবে, 
                         তখন HomePage কম্পোনেন্টটি নতুন key এর জন্য রিমাউন্ট হবে।
                         প্রথমটি শুধুমাত্র একবার মাউন্ট হবে, এবং কম্পোনেন্ট রিমাউন্ট করবে না।
                         দ্বিতীয়টি প্রতিবার নতুন key দিয়ে রেন্ডার হওয়ায় প্রতিবার রিমাউন্ট হবে।
                         
                         <Route exact path="/" element={<HomePage />} /> এতে render প্রপার্টির প্রয়োজন নেই, কারণ React Router v6 এ element প্রপার্টি সরাসরি JSX কম্পোনেন্ট রেন্ডার করার জন্য উপযুক্ত।
                         এবং এতে render প্রপার্টি আসলে কাজও করবে না, render প্রপার্টি শুধুমাত্র React Router v5 বা তার পূর্ববর্তী সংস্করণগুলিতে বিদ্যমান ছিল।
                         যদি তোমার লক্ষ্য প্রতিবার রুট অ্যাক্সেস করার সময় কম্পোনেন্টটি রিমাউন্ট করা হয়, তবে key ব্যবহার করার বিকল্প হিসেবে useNavigate বা useLocation হুক দিয়ে রেফ্রেশ বা পুনরায় লোড করার প্রয়োজনীয়তা পূরণ করতে পারো। তবে অধিকাংশ ক্ষেত্রে এটি না করলেও চলে।
                         key={Date.now()} যুক্ত করার প্রয়োজন নেই: React Router v6 স্বয়ংক্রিয়ভাবে রাউট পরিবর্তন ও কম্পোনেন্ট হ্যান্ডেল করে, তাই আলাদা করে key দিয়ে প্রতিবার রিমাউন্ট করানোর দরকার নেই।
                         
                         
                         */}

                         {/* <Route exact path="/" render={(props) => <HomePage {...props} key={Date.now()} />} /> */}

                         <Route exact path="/" element={<HomePage />} />
                         <Route exact path="/login" element={<UserLoginPage setUser={this.setUser} user={this.state.user} />} />
                         <Route exact path="/register" element={<RegisterPage setUser={this.setUser} user={this.state.user} />} />
                         <Route exact path="/forget" element={<ForgetPasswordPage />} />
                         <Route exact path="/reset/:id" element={<ResetPasswordPage />} />
                         <Route exact path="/profile" element={<ProfilePage setUser={this.setUser} user={this.state.user} />} />

                         <Route exact path="/contact" element={<ContactPage />} />
                         <Route exact path="/purchase" element={<PurchasePage />} />
                         <Route exact path="/privacy" element={<PrivacyPage />} />
                         <Route exact path="/refund" element={<RefundPage />} />
                         <Route exact path="/about" element={<AboutPage />} />
                         <Route exact path="/productdetails/:code" element={<ProductDetailsPage user={this.state.user} />} />
                         <Route exact path="/notification" element={<NotificationPage />} />
                         <Route exact path="/favourite" element={<FavouritePage user={this.state.user} />} />
                         <Route exact path="/cart" element={<CartPage user={this.state.user} />} />


                         {/* <Link to={"/productcategory/" + CatList.category_name}> লিংকটি ব্যবহার করে, category_name এর মান অনুযায়ী URL তৈরি করা হচ্ছে।
                    যদি CatList.category_name এর মান "electronics" হয়, তাহলে লিংকটি /productcategory/electronics হবে,
                    এই লিংকটি ক্লিক করলে React Router URL-টি /productcategory/electronics এর মতো রাউটে পাঠায়, যা <Route exact path="/productcategory/:category" element={ProductCategoryPage} /> 
                    রাউটারের সাথে মিল খুঁজে ProductCategoryPage কম্পোনেন্টকে লোড করবে।
                    AppRoute.js এ আপনি একটি রাউট <Route exact path="/productcategory/:category" element={ProductCategoryPage} /> তৈরি করেছেন যা /productcategory/:category পাথের জন্য ProductCategoryPage কম্পোনেন্ট লোড করবে।
                    :category অংশটি একটি ডায়নামিক প্যারামিটার, যা রাউটারের জন্য URL-এর ডায়নামিক অংশ হিসেবে কাজ করে এবং এটি যে কোনো ক্যাটাগরি নাম ধারণ করতে পারে। উদাহরণস্বরূপ:
                    যদি URL হয় /productcategory/electronics, তাহলে category প্যারামিটারটি "electronics" হিসেবে ধরা হবে।
                    যদি URL হয় /productcategory/fashion, তাহলে category প্যারামিটারটি "fashion" হিসেবে ধরা হবে।
                    ProductCategoryPage কম্পোনেন্টের match.params.category এর মাধ্যমে এই category প্যারামিটারটি অ্যাক্সেসযোগ্য হবে।
                    */}
                         <Route exact path="/productcategory/:category" element={<ProductCategoryPage />} />

                         <Route exact path="/productsubcategory/:category/:subcategory" element={<ProductSubCategoryPage />} />

                         <Route exact path="/productbysearch/:searchkey" element={<SearchPage />} />
                         
                         <Route exact path="/orderlist" element={<OrderListPage user={this.state.user} />} />
                    



                    </Routes>

               </Fragment>
          )
     }
}

export default AppRoute
